import {
  Icon,
  IconColor,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoEmspUserListIsWebauthnEnabledCellProps
  extends CellContext<EmspUserModel, EmspUserModel['isWebauthnEnabled']> {}

export const EmspBoEmspUserListIsWebauthnEnabledCell = (
  props: EmspBoEmspUserListIsWebauthnEnabledCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return getValue() ? (
    <Icon name="check-circle" color={IconColor.Success} />
  ) : (
    <Icon name="x-circle" color={IconColor.Error} />
  );
};
